import { DEFAULT_CONTENT } from "./constants";
// eslint-disable-next-line import/prefer-default-export
export var getDefaultContent = function getDefaultContent(severity) {
  return DEFAULT_CONTENT[severity] || DEFAULT_CONTENT.info;
};